import en_to_ko from "./en_to_ko";
import en_to_pt from "./en_to_pt";
import en_to_ar from "./en_to_ar";

export const ChartConfig = {
    chart_title : {
      padding:30,
      display: true,
      fontSize: 25,
      text: []
    },
    barchart_layout : {
        padding: {
            left: 50,
            right: 50,
            top: 50,
            bottom: 50
        }
    },
    piechart_layout : {
        padding: {
            left: 150,
            right: 150,
            top: 50,
            bottom: 50
        }
    },
    piechart_colors_blue : [
        '#ABD9D6',
        '#0087C0',
        '#0D3D56',
        '#E0E169'
    ],
    barchart_colors: [
        '#0D3D56',
        '#E0E169',
        '#ABD9D6',
        '#0087C0'
    ],
    barchart_colors1: [
'#0D3D56',
'#0D3D56',
'#0D3D56',
'#0D3D56',
'#0D3D56',

    ],
    stackbarchart_colors: [
        '#0D3D56',
        '#E0E169',
        '#ABD9D6',
        '#0087C0'
    ],
    piechart_colors_blue3 : [
        '#ABD9D6',
        '#0087C0',
        '#0D3D56',
    ],
    piechart_colors_blue5 : [
        '#ABD9D6',
        '#0087C0',
        '#0D3D56',
        '#E0E169',
        '#329D86'
    ],
    piechart_colors_blue6 : [
        '#ABD9D6',
        '#0087C0',
        '#0D3D56',
        '#E0E169',
        '#329D86',
        '#87888A'
    ],
    polarArea_colors_col1:[
        '#3b3d3e', //black
        '#cb331f', //red
        '#abd9d6', //blue
        '#239561',  //green

    ],

    policyPolar:[
        '#3b3d3e', //black
        '#cb331f', //red
        '#abd9d6', //blue
        '#239561',  //green
    ]
    ,
    piechart_colors : [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)'
    ],
    blue_shades : [
        'rgba(202,223,232, 1)',
        'rgba(180,212,224, 1)',
        'rgba(156,200,216, 1)',
        'rgba(124,187,207, 1)',
        'rgba(75,172,198, 1)',
        'rgba(70,160,185, 1)',
        'rgba(64,148,171, 1)',
        'rgba(57,134,155, 1)',
        'rgba(49,118,137, 1)'
    ],
    piechart_legend : {
        display: true,
        position: 'right'
    },
    polarAreaChart_legend:{
        display:true,
        position:'right'
    },
    barchart_legend : {
        display: false
    },
    barchart_legend_bottom : {
        display: true,
        position: 'bottom',
        labels:{
          fontSize: 16
        }
    },
    barchart_legend_top : {
        display: true,
        position: 'top',
        labels:{
          padding:40
        }
    },
    barchart_tooltips : {
        enabled: true,
        mode: 'single',
        callbacks: {
            label: function(tooltipItems, data) {
                return data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index] + '%';
            }
        }
    },
    barchart_tooltips_labels : {
        enabled: true,
        mode: 'single',
        callbacks: {
            label: function(tooltipItems, data) {
                return data.datasets[tooltipItems.datasetIndex].label + ':' + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index] + '%';
            }
        }
    },

    barchart_tooltips_simple : {
        enabled: true,
        mode: 'single',
        callbacks: {
            label: function(tooltipItems, data) {
                return data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
            }
        }
    },
    barchart_tooltips_usd : {
        enabled: true,
        mode: 'single',
        callbacks: {
            label: function(tooltipItems, data) {
                return data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index] + ' (000,000 USD)';
            }
        }
    },
    piechart_tooltips : {
        enabled: true,
        mode: 'single',
        callbacks: {
            label: function(tooltipItems, data) {
                return data.labels[tooltipItems.index] + ': ' + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index] + '%';
            }
        }
    },
    polarchart_tooltips : {
        enabled: true,
        mode: 'single',
        callbacks: {
            label: function(tooltipItems, data) {
                return data.labels[tooltipItems.index];
            }
        }
    },
    percentage_datalabels : {
        display: true,
        align	: 'end',
        anchor : 'end',
        borderRadius: 4,
        color: ['#000000', '#ffffff', '#ffffff', '#000000', '#000000'],
        font: {
            weight: 'bold',
            size: 10
        },
        backgroundColor: function(context) {
            return context.dataset.backgroundColor;
        },
        formatter: function(value, context) {
            //original
            //return value + '%';
            //edit by os
            return value + '.';
        }
    },
    percentage_datalabels_small : {
        align	: 'center',
        anchor : 'center',
        borderRadius: 4,
        color: '#001f3f',
        padding: {
            top: 1,
            bottom: 0
        },
        font: {
            size: 16,
            weight: 'bold'
        },
        backgroundColor: function(context) {
            return context.dataset.backgroundColor;
        },
        formatter: function(value, context) {
            return value + ' %';
        },
        display: function(context) {
            var index = context.dataIndex;
            var value = context.dataset.data[index];
            return value > 0; // display labels with a value greater than 0
        }
    },
    percentage_datalabels_small_white : {
        align	: 'center',
        anchor : 'center',
        borderRadius: 4,
        color: '#ffffff',
        padding: {
            top: 1,
            bottom: 0
        },
        font: {
            size: 16,
            weight: 'bold'
        },
        backgroundColor: function(context) {
            return context.dataset.backgroundColor;
        },
        formatter: function(value, context) {
            return value + ' %';
        },
        display: function(context) {
            var index = context.dataIndex;
            var value = context.dataset.data[index];
            return value > 0; // display labels with a value greater than 0
        }
    },
    simple_datalabels : {
        align	: 'center',
        anchor : 'center',
        borderRadius: 4,
        color: '#ffffff',
        font: {
            weight: 'bold',
            size: 16
        },
        backgroundColor: function(context) {
            return context.dataset.backgroundColor;
        },
        display: function(context) {
            var index = context.dataIndex;
            var value = context.dataset.data[index];
            return value > 0; // display labels with a value greater than 0
        }
    },
    simple_datalabels_black : {
        align	: 'center',
        anchor : 'center',
        borderRadius: 4,
        color: '#000000',
        font: {
            weight: 'bold',
            size: 16
        },
        backgroundColor: function(context) {
            return context.dataset.backgroundColor;
        },
        display: function(context) {
            var index = context.dataIndex;
            var value = context.dataset.data[index];
            return value > 0; // display labels with a value greater than 0
        }
    },
    usd_datalabels : {
        display: true,
        align	: 'end',
        anchor : 'end',
        borderRadius: 4,
        color: '#ffffff',
        padding: {
            top: 1,
            bottom: 1,
            left: 1,
            right: 1
        },
        font: {
            size:16,
            weight: 'bold'
        },
        backgroundColor: function(context) {
            return context.dataset.backgroundColor;
        },
        formatter: function(value, context) {
            return '$' + value.toLocaleString();
        }
    },
    usd_datalabels_black : {
        display: true,
        align	: 'end',
        anchor : 'end',
        borderRadius: 4,
        color: '#000000',
        padding: {
            top: 1,
            bottom: 1,
            left: 1,
            right: 1
        },
        font: {
            size:16,
            weight: 'bold'
        },
        backgroundColor: function(context) {
            return context.dataset.backgroundColor;
        },
        formatter: function(value, context) {
            return '$' + value.toLocaleString();
        }
    },
    percentage_ticks : {
        fontSize: 18,
        beginAtZero:true,
        stepSize: 20,
        min:0,
        max:100,
        callback: function(value, index, values) {
            return value + '%';
        }
    },
    score_ticks : {
        fontSize: 18,
        beginAtZero:true,
        stepSize: 20,
        min:0,
        max:100
    },
    simple_ticks : {
        fontSize: 18,
        beginAtZero:true,
        stepSize: .1,
        min:0
    },
    data_ticks : {
        fontSize: 18
    },
    barchart_scales : {
        xAxes: [{
            display: true,
            ticks: {
              fontSize: 18,
              autoSkip: false
            }
        }],
        yAxes: [{
            display: true,
            ticks: {
                fontSize: 18,
                beginAtZero:true,
                stepSize: 20,
                min:0,
                max:100,
                callback: function(value, index, values) {
                    return value + '%';
                }
            },
            gridLines: {
                display: true
            }
        }]
    },
    barchart_scales_score_y : {
        xAxes: [{
            display: true,
            ticks: {
              fontSize: 13,
              autoSkip: false
            },
        }],
        yAxes: [{
            display: true,
            ticks: {
                fontSize: 18,
                beginAtZero:true,
                stepSize: 20,
                min:0,
                max:100
            },
            scaleLabel: {
                fontSize: 20,
                display: true,
                labelString: 'Score (0-100)'
            },
            gridLines: {
                display: true
            }
        }]
    },
    scales_y_usd_x_sdg6 : {
        xAxes: [{
            display: true,
            ticks: {
              fontSize: 18,
              autoSkip: false
            },
            scaleLabel: {
                fontSize: 20,
                display: true,
                labelString: 'SDG 6 indicator'
            },
        }],
        yAxes: [{
            display: true,
            ticks: {
                fontSize: 18,
                beginAtZero:true
            },
            scaleLabel: {
                fontSize: 20,
                display: true,
                labelString: '(\'000,000 USD)'
            }
        }]
    },
    scales_y_score_x_sdg6 : {
        xAxes: [{
            display: true,
            ticks: {
              fontSize: 18,
              autoSkip: false
            },
            scaleLabel: {
                fontSize: 20,
                display: true,
                labelString: 'SDG 6 indicator'
            },
        }],
        yAxes: [{
            display: true,
            ticks: {
                fontSize: 18,
                beginAtZero:true,
                min: 0,
                max: 100,
                stepSize: 10,
            },
            scaleLabel: {
                fontSize: 20,
                display: true,
                labelString: 'Score (0-100)'
            }
        }]
    },
    scales_y_employees_x_sdg6 : {
        xAxes: [{
            display: true,
            stacked: true,
            ticks: {
                fontSize: 18,
                autoSkip: false
              },
              scaleLabel: {
                  fontSize: 20,
                  display: true,
                  labelString: 'SDG 6 indicators'
              },
        }],
        yAxes: [{
            display: true,
            stacked: true,
            ticks: {
                fontSize: 18,
                autoSkip: false,
            },
            scaleLabel: {
                fontSize: 20,
                display: true,
                labelString: 'Number of employees'
            }
        }]
    },
    scales_y_percent_x_sdg6 : {
        xAxes: [{
            display: true,
            ticks: {
              fontSize: 18,
              autoSkip: false
            },
            scaleLabel: {
                fontSize: 20,
                display: true,
                labelString: 'SDG 6 indicator'
            },
        }],
        yAxes: [{
            display: true,
            ticks: {
                fontSize: 18,
                beginAtZero:true,
                stepSize: 20,
                min:0,
                max:100,
                callback: function(value, index, values) {
                    return value + '%';
                }
            },
            gridLines: {
                display: true
            }
        }]
    },
    horizontal_barchart_scales : {
        yAxes: [{
            display: true,
            ticks: {
              fontSize: 18,
              autoSkip: false
            }
        }],
        xAxes: [{
            display: true,
            ticks: {
                fontSize: 18,
                beginAtZero:true,
                stepSize: 20,
                min:0,
                max:100,
                callback: function(value, index, values) {
                    return value + '%';
                }
            },
            gridLines: {
                display: true
            }
        }]
    },
    barchart_scales_simple_y : {
        xAxes: [{
          display: true,
          ticks: {
              fontSize: 18,
              beginAtZero:true,
              stepSize: 10,
              min:0
          }
        }],
        yAxes: [{
          display: true,
        }]
    },
    barchart_scales_simple_x : {
        xAxes: [{
          display: true
        }],
        yAxes: [{
          display: true,
          ticks: {
              fontSize: 18,
              beginAtZero:true
          }
        }],
    }
};
var en_to_es = {
    'Unknown/No Data':'Sin evidencia',
'baseline':'Base de referencia',
'current':'Valor Actual',
'aspiration (2030)':'Valor Aspiracional (2030)',
'not critical':'No crítico',
'somewhat critical':'Algo crítico',
'significantly critical':'Significativamente crítico',
'very critical':'Muy crítico',
'low capacity':'Capacidad baja',
'partial capacity':'Capacidad parcial',
'significant capacity':'Capacidad significativa',
'complete capacity':'Capacidad plena',
'yes':'Sí',
'no':'No',
'inadequate capacity':'Capacidad inadecuada',
'adequate capacity':'Sin capacidad',
'no capacity' : 'Capacidad adecuada',
'unknown':'Desconocida',
'Unknown':'Desconocida',
'Generic User': 'Generic User',
'National Team Member': 'National Team Member',
'other':'Otro',
'not applicable':'No aplica',
'in development':'En desarrollo',
'In development': 'En desarrollo',
'lead ministry/ institution 1':'El Ministerio / Institución responsable 1',
'lead ministry/ institution 2':'El Ministerio / Institución responsable 2',
'lead ministry/ institution 3':'El Ministerio / Institución responsable 3',
'detail':'Detalles',
'by consultation':'Por consultas',
'by law (ad-hoc)':'Por ley (ad-hoc)',
'by law (other)':'Poy leuy (otra)',
'policy role is not defined':'Papel de la política del agua no se define',
'very important':'Muy importante',
'somewhat important':'Algo importante',
'not important':'No importante',
'very high':'Muy alto',
'significant':'Significativo',
'low':'Bajo',
'none':'Ninguna',
'informal only':'Sólo informal',
'other (describe)':'Otro (describir)',
'excellent':'Excelente',
'adequate':'Adecuado',
'inadequate':'Inadecuado',
'never':'Nunca',
'sometimes':'A veces',
'often':'A menudo',
'always':'Siempre',
'junior':'Junior',
'senior':'Profesional',
'director/executive':'Director(a)/Ejecutivo(a)',
'male':'Mujeres',
'female':'Hombres',
'Score (0-100)': 'Escala (0-100)',
'6.1.1 Proportion of population using': '6.1.1 Proporción de la población que dispone de servicios de suministro ',
'safely managed drinking water services': 'de agua potable gestionados de manera segura',
'6.2.1 Proportion of population using': '6.2.1 Proporción de la población que utiliza servicios de saneamiento',
'safely managed sanitation services': 'gestionados de manera segura',
'6.3.1 Proportion of wastewater safely treated': '6.3.1 Porcentaje de aguas residuales tratadas de manera segura',
'6.3.2 Proportion of water bodies with good ambient water quality': '6.3.2 Porcentaje de masas de agua de buena calidad',
'6.4.1 Change in water use efficiency over time': '6.4.1 Cambio en la eficiencia del uso del agua con el tiempo',
'6.4.2 Level of water stress: freshwater withdrawal': '6.4.2 Nivel de estrés por escasez de agua: extracción de agua dulce ',
'in percentage of available freshwater resources': 'como proporción de los recursos de agua dulce disponibles',
'6.5.1 Degree of integrated water resources management': '6.5.1 Grado de aplicación de la ordenación integrada de los recursos hídricos',
'6.5.2 Proportion of transboundary basin area with': '6.5.2 Proporción de la superficie de cuencas transfronterizas con un arreglo',
'an operational arrangement for water cooperation': 'operacional para la cooperación en la esfera del agua',
'6.6.1 Change in the extent of water-related ecosystems over time': ['6.6.1 Cambio en la extensión de los ecosistemas relacionados con el agua','a lo largo del tiempo'],
'Percentage': 'Porcentaje',
'Population using improved sanitation services': 'Proporción de la población que utiliza servicios de saneamiento gestionados de manera segura',
'Population using hygiene facility with soap and water at home': 'Población que usa instalaciones para lavarse las manos con agua y jabón',
'Commercial establishments': 'Establecimientos comerciales',
'Non-hazardous industries': 'Industrias no peligrosas',
'Hazardous industries': 'Industrias peligrosas',
'Household sources': 'Origen doméstico',
'Enabling': 'Entorno','environment score': 'favorable',
'Institutions and': 'Instituciones y','participation score': 'participación',
'Management': 'Instrumentos','instruments score':'de gestión',
'Financing score': 'Financiamiento',
'Change in the area extent of water-related ecosystems': 'Cambio en la extensión del área de ecosistemas relacionados con el agua',
'Change in quantity of water contained within these ecosystems': 'Cambio en la cantidad de agua contenida dentro de estos ecosistemas',
'Capacity building needed at the national level': 'Desarrollo de capacidad de capacidad necesaria a nivel nacional ',
'to achieve SDG 6 in the country-building':'para lograr el ODS 6 en el país',
'Capacity available at the national level':'Capacidad disponible a nivel nacional ',
'to achieve SDG 6 in the country-available': 'para lograr el ODS 6 en el país',
'Importance of human resources development for implementation of SDG 6': ['Importancia del desarrollo de recursos humanos para la ','implementación del ODS 6'],
'Importance of knowledge and data in implementation of SDG 6': 'Importancia del conocimiento y los datos en la implementación del ODS 6',
'Importance of human capacity to make policy for the implementation of SDG 6': ['Importancia de la capacidad humana para formular políticas ','para la implementación del ODS 6'],
'Institutions considering structural changes to achieve SDG 6': 'Institutions considering structural changes to achieve SDG 6',
'National policies and implementation plans for SDG 6': 'Políticas nacionales y planes de implementación para los indicadores del ODS 6',
'Lack of staff and time as an obstacle to achieve SDG 6': 'Falta de personal y tiempo como obstáculo para lograr el ODS 6',
'Mechanisms existing for cooperation with private sector to achieve SDG 6': ['Mecanismos existentes para la cooperación con el sector privado ','para lograr el ODS 6'],
'Level of cooperation with other countries to achieve SDG 6': 'Nivel de cooperación con otros países para lograr el ODS 6',
'Development partners collaborating with government for each SDG 6 indicator': ['Asociados para el desarrollo que colaboran con el gobierno ','para cada indicador del ODS 6'],
'Number of partners': 'Número de asociados',
'Number of employees': 'Número de empleados',
'Number of events': 'Número de eventos',
'SDG 6 indicator': 'Indicador del ODS 6',
'Availability of financial flows for each SDG 6 Indicators': 'Disponibilidad de flujos financieros para cada indicador del ODS 6',
'Estimated funds to achieve each SDG 6 indicators by 2030': 'Fondos estimados para lograr cada indicador del ODS 6 para 2030',
'Funds needed and available for each SDG 6 indicators in the current year': 'Fondos necesarios y disponibles para cada indicador del ODS 6 en el año en curso',
'Progress on accountability, attracting funds and funding for equity': ['Progreso en la rendición de cuentas, la atracción de las fuentes de','financiación y los recursos que promuevan la equidad'],
'Mechanisms for including civil society in': ['Mecanismos para incluir a la sociedad civil en el proceso', 'de planificación financiera para el ODS 6'],
'Available funds as % of funds needed': 'Fondos disponibles como % de fondos necesarios',
'Positive responses for financial flows': 'Respuestas positivas para flujos financeiros',
'Funds available (\'000,000 USD)': 'Fondos disponibles (\'000,000 USD)',
'Funds needed (\'000,000 USD)': 'Fondos necesarios (\'000,000 USD)',
'Accountability': 'Responsabilidad financiera',
'Attracting funds': 'Atracción de las fuentes de financiación ',
'Funding for equity': 'Recursos que promuevan la equidad',
'Gender considerations incorporated by national stakeholders': ['Análisis de género realizado para informar las políticas nacionales',
                             'sobre las cuestiones de género para el ODS 6'],
'Gender analysis undertaken to inform national policy': ['Asignación de recursos por parte del ministerio de tutela para',
                             'implementar estrategias de género para el ODS 6'],
'Resources allocation by lead ministry to implement': ['Consideraciones de género incorporadas por las organizaciones',
                             'interesadas a nivel nacional para contribuir al ODS 6'],
'Performance-based mechanisms for staff to pursue gender':['Performance-based mechanisms for staff to pursue gender',
                             'mainstreaming in their work for SDG 6'],
'Protection plans implemented for critical': ['Planes de protección para infraestructura crítica implementados ',
                'para lograr el ODS 6'],
'Proportion of critical public infrastructure located in': ['Proporción de infraestructura pública crítica situada en áreas de riesgo ',
                'de desastres relacionadas con cada indicador del ODS 6'],
'Proportion of critical public infrastructure with hazard, risk and': ['Proporción de infraestructura pública crítica con análisis de peligro, riesgo ',
                'y vulnerabilidad ya completado para cada indicador del ODS 6'],
'Predicted economic loss': 'Pérdida económica prevista',
'Funds allocated for post-disaster infrastructure reconstruction': 'Fondos asignados para la reconstrucción de la infraestructura después de un desastre',
'Transparency in formulation of new policies and implementation': ['Transparency in formulation of new policies and implementation',
          'of existing regulations/policies for each SDG 6 indicator'],
'Fair and equitable access of stakeholders to the': ['Fair and equitable access of stakeholders to the',
          'development and implementation of policies for SDG 6'],
'Integrity training promoted at least once a year': ['Integrity training promoted at least once a year',
          'in lead ministries/institutions for SDG 6'],
'Formulation of new policies': 'Formulation of new policies',
'Implementation of existing regulations': 'Implementation of existing regulations',
"No evidence": "Sin evidencia",
"Significant": "Significativo",
"Adequate": "Adecuado",
"Inadequate": "Inadecuado",
"In progress": "En desarrollo",
"Capacity": "Desarrollo de capacidades",
// "DRR/Resilience": "RRD/Resiliencia",
"DRR/Resilience": "Reducción del riesgo de catástrofes y resiliencia",
"Finance": "Financiación",
"Gender": "Integración de género",
"Indicator": "Indicador",
"Integrity": "Integridad",
"Policy & Institutional": "Gobernabilidad",
"Target": "Meta",
"Overall Progress": "Progreso general",
"Overall current capacity": "Capacidad actual",
"Strengthening mechanisms": "Mecanismos de fortalecimiento",
"Information and Assessments": "Mecanismos de financiación",
// "Infrastructure": "Infraestructuras",
"Infrastructure": "Accesibilidad de datos",
"Data accessiblilty":"Accesibilidad de datos",
"Strategies": "Planificación estratégica",
// "Adequacy of financial flows": "Adecuación de las corrientes financieras",
"Adequacy of financial flows": "Planificación financiera",
// "Financing for equity": "Financiación para la equidad",
"Financing for equity": "Incentivos públicos",
"Funding Sources": "Rendición de cuentas",
"Governance": "Participación de las mujeres",
"National policy": "Análisis de género",
"Organisation mainstreaming": "Formación y recursos",
"Policy and Integrity": "Responsabilidad y transparencia",
"Public Sector Integrity": "Justicia y equidad",
// "Whistle-blower Protection": "Protección de denunciantes",
"Whistle-blower Protection": "Procesos reglamentarios",
"Awareness": "Sensibilización del público",
"Coordination & cooperation": "Coordinación y cooperación",
"Policy for equity": "Planificación política y equidad",
"Level of available capacity at the national level for achieving SDG 6": "Capacidad disponible a nivel nacional para lograr el ODS 6",
"Mechanisms addressing capacity building at the national":"Mecanismos que abordan el desarrollo de capacidad a nivel nacional para los indicadores del ODS 6",
"Level of available capacity at the national level":"Nivel de capacidad disponible a nivel nacional para alcanzar los indicadores del ODS 6",
"Lead Ministries/Institutions on track to build critical":['Ministerios / Instituciones en vías de construir la capacidad crítica para los planes de acción en apoyo a','los indicadores del OSD 6'],
"Financing and expenditure plans developed and publicly":['Proporción estimada de fondos disponibles en relación con los','fondos necesarios para los indicadores del ODS 6'],
"Estimated proportion of funds available in relation to":['Planes de financiación y gastos desarrollados y disponibles públicamente','para los indicadores del ODS 6'],
"Mechanisms for including civil society in the financial":['Mecanismos para incluir a la sociedad civil en el proceso de planificación financiera','de los indicadores del ODS 6'],
"Established financial accountability mechanisms for":['Mecanismos establecidos de responsabilidad financiera para los','indicadores del ODS 6'],
"Securing different funding sources to support national":['Diferentes fuentes de financiamiento para apoyar las','políticas nacionales y la implementación de los indicadores del ODS 6'],
"Incentives for environmentally sustainable and efficient":['Incentivos para tecnologías ambientalmente sostenibles y eficientes','para los indicadores del ODS 6'],
"Mechanisms to reach specific population groups for SDG 6":['Mecanismos para llegar a grupos de población específicos para los indicadores del ODS 6'],
"National DRR strategies adopted in line ":['Estrategias nacionales de RRD adoptadas de acuerdo con el Marco de Sendai','para los indicadores del ODS 6'],
"Integration of climate change adaptation into ":['Integración de la adaptación al cambio climático en las estrategias nacionales','para los indicadores del ODS 6'],
"National funding mechanisms for DRR strategies for SDG 6 indicators":['Mecanismos nacionales de financiación de las estrategias de RRD para los','indicadores del ODS 6'],
"Indedpendent reviews of the implementation of DRR":['Revisiones independientes de la implementación de','estrategias de RRD para los indicadores del ODS 6'],
"Hazard and risk data accessible and available to the public":['Datos sobre peligros y riesgos accesibles y disponibles para el público','para los indicadores del ODS 6'],
"Predicted economic loss and funds allocated to address":['Pérdida económica prevista y fondos asignados para abordar la reconstrucción de la','infraestructura para cada indicador del ODS 6'],
"Mechanisms of accountability to prevent and detect":['Mecanismos de rendición de cuentas para prevenir y detectar','la corrupción para los indicadores del ODS 6'],
"Fair and equitable access to the development and implementation":"Acceso justo y equitativo al desarrollo e implementación de políticas para los indicadores del ODS 6",
"Regulatory processes are simple and transparent":"Los procesos regulatorios son simples y transparentes para los indicadores del ODS 6",
"Anti-corruption action plans shared between government and ":["Planos de acción anticorrupción compartido entre el gobierno","y los donantes para los indicadores del ODS 6"],
"Public financial management and procurement used to prevent":['Gestión de las finanzas públicas y adquisiciones utilizadas para','prevenir y detectar la corrupción para los  indicadores del ODS 6'],
"Mechanisms for the allocation of responsibilities among lead":['Mecanismos para la asignación de responsabilidades entre los','Ministerios / Instituciones para los indicadores del ODS 6'],
"Mechanisms adopted to address the lack of reliable data for":["Mecanismos adoptados para abordar la falta de datos fiables para los","indicadores del ODS 6"],
"Cooperation with private sector to achieve SDG 6":["Cooperación con el sector privado para alcanzar los","indicadores del ODS 6"],
"Cooperation with the development partners (international organizations, donors, NGOs)":['Cooperación con los socios de desarrollo (organizaciones internacionales,','donantes, ONG) para alcanzar los indicadores del ODS 6'],
"Level of cooperation and exchange of information with other":['Nivel de cooperación e intercambio de información con otros','países para los indicadores del ODS 6'],
"Public awareness campaigns organized to inform citizens on":['Campañas de concienciación pública organizadas para informar a los ciudadanos','sobre los desafíos y el progreso de los indicadores del ODS 6'],
"Gender mainstreaming objectives considered for":['Objetivos de integración de género considerados para los','indicadores del ODS 6'],
'Independent reviews of the implementation of DRR':['Revisiones independientes de la implementación de estrategias de','RRD para los indicadores del ODS 6'],
'Regulatory processes are simple and transparent ':['Los procesos regulatorios son simples y transparentes para los','indicadores del ODS 6'],

'Gender analysis undertaken to inform national policies ':['Análisis de género realizado para informar las políticas nacionales para los','indicadores del ODS 6'],
"Gender dimensions incorporated by national stakeholders ":['Dimensiones de género incorporadas por actores nacionales','en los estudios de los indicadores del ODS 6'],
"Adequate resources allocated to implement gender ":['Recursos adecuados asignados para implementar los objetivos de integración de género','para los indicadores del ODS 6'],
"Inclusion of gender specialists in decison-making processes":['Inclusión de especialistas en género en los procesos de toma de decisiones para los','indicadores del ODS 6'],
"Training to raise awareness on gender equality within lead":['Capacitación para crear conciencia sobre la igualdad de género en los','ministerios / instituciones para los indicadores del ODS 6'],
"Staff in lead Ministries/Institutions for each SDG 6 indicator":['Personal de los ministerios / instituciones principales para cada indicador del','ODS 6'],
'Long-term policy options and mechanisms for building critical ':['Políticas y mecanismos a largo plazo para fortalecer las ','capacidades críticas a nivel nacional para el ODS 6'],
'Human resources development ': ['Desarrollo y mejora  ', 'de recursos humanos'],
'Access to information ': ['Acceso a la información ','y al conocimiento'],
'Science, technology ': ['Ciencia, tecnología ','e innovación'],
'Inclusion, participation, ': ['Inclusión, participación, ','equidad y empoderamiento de ','los grupos excluidos'],
'Status of policies to align and inform on investments to ': ['Situación de las políticas para alinear e informar sobre las','inversiones para cumplir con los objetivos de integración de','género para el ODS 6'],
'Status of resources allocated to implement gender ': ['Estado de los recursos asignados a la implementación de los','objetivos de las estrategias de la perspectiva de género','en el ODS 6'],
'Consultation with national gender specialists in decision-making for SDG 6': ['Consulta con especialistas nacionales en género para la toma de','decisiones para el ODS 6'],
'Institutional commitment to promote gender equality for achieving SDG 6': ['Compromiso institucional con la igualdad de género para','lograr el ODS 6'],
'Staff in lead Ministries/Institutions for each SDG 6 indicators': ['Personal en los principales Ministerios/Instituciones para cada indicador','del ODS 6'],
'Staff responsible for addressing water related gender issues in': ['Personal responsable de abordar las cuestiones de género relacionadas','con el agua en los principales Ministerios/Instituciones para cada','indicador de ODS 6'],
'Annual status of training to raise awareness on gender ': ['Estado de las capacitaciones para crear conciencia sobre','cuestiones de género en los principales Ministerios/Instituciones','para el ODS 6'],
'Public awareness efforts led by the national government for achieving SDG 6': ['Esfuerzos de concientización pública liderados por el gobierno nacional ','para lograr el ODS 6'],
'Status of water related policies for equity at national level for achieving SDG 6 ':['Estado de las políticas de equidad relacionadas con el agua ','a nivel nacional para lograr el ODS 6'],
'Challenges in water policymaking at national level for achieving SDG 6': ['Desafíos en la formulación de políticas del agua a nivel nacional ','para lograr el ODS 6'],
'Events, meetings and workshops organized by the government for each SDG 6 indicator': ['Eventos, reuniones y talleres organizados por el gobierno para cada ','indicador SDG 6'],
'Status of national policies and implementation plans for achieving SDG 6': ['Estado de las políticas de equidad relacionadas con el agua','a nivel nacional para lograr el ODS 6'],
'Attribution of roles at the national level for SDG 6': ['Atribución de funciones a nivel nacional para el ODS 6'],
'chart10_label_policy_component': ['Ninguna implementación','Implementación parcial','Implementación completa'],
'chart8_label_policy_component': [['Discordancia entre ','los límites ','hidrológicos y ','administrativos'],['Asignación de los ','recursos hídricos'],
                                ['Capacidad de ','gobiernos locales ','y regionales'], ['Cumplimiento de las','normas ambientales'],
                                'Regulación económica', ['Participación ','ciudadana']],
'chart7_label_policy_component': [['Poblaciones ','pobres'],['Poblaciones que','viven en barrios','marginales o ','asentamientos ', 'informales'],['Poblaciones que ','viven en zonas','remotas o zonas ','de difícil acceso'],
                                ['Poblaciones ','indígenas'],['Personas como ','los desplazados ','internos o ','refugiados'],'Mujeres',
                                'Minorías étnicas', ['Personas ','discapacitadas'],['Poblaciones con ','enfermedades']],
'Status of national DRR strategies adopted in line with the ': ['Estado de las estrategias nacionales de reducción del riesgo de ','desastres adoptadas de conformidad con el Marco de Sendai para ','apoyar el logro del ODS 6'],
'Status of integrating climate change adaptation into ': ['Estado de integración de la adaptación al cambio climático en las ','estrategias nacionales para el ODS 6'],
'Status of national funding mechanisms for DRR in support of SDG 6': ['Estado de los mecanismos de financiación nacionales para la ', 'reducción del riesgo de desastres para apoyar el logro del ODS 6'],

'Status of independent reviews of the implementation of ': ['Estado de las revisiones independientes de la implementación de ','estrategias de reducción del riesgo de desastres para el ODS 6'],
'Availability status of multi-hazard national risk assessments for SDG 6': ['Estado de disponibilidad de evaluaciones nacionales de riesgos ','múltiples para el ODS 6'],
'Hazard and Risk data accessible to the public for SDG 6 indicator':['Hazard and Risk data accessible to the public for SDG 6 indicator'],
'Status of policies and mechanisms to make hazard and ': ['Estado de las políticas y mecanismos para hacer que los datos ','sobre peligros y riesgos estén disponibles públicamente ','para el ODS 6'],
'Programmes to enhance awareness on water-related disaster risks for SDG 6': ['Programas de concientización sobre el riesgo de desastres ','relacionados con el agua para el ODS 6'],
'Status of funding for post-disaster infrastructure rehabilitation for SDG 6': ['Estado de los fondos para la rehabilitación de la infraestructura ','después de un desastre para el ODD 6'],
'Integrity assessment of water related policymaking for each SDG 6': ['Evaluación de la integridad en la formulación de políticas de agua ','para lograr el ODS 6'],
'Integrity assessment of regulatory processes for achieving SDG 6': ['Evaluación de integridad de los procesos regulatorios para ','lograr el ODS 6'],
'Integrity assessment of international funding for achieving SDG 6': ['Evaluación de la integridad en el financiamiento internacional para ','lograr el ODS 6'],
'Public sector integrity assessment for achieving SDG 6': ['Evaluación de la integridad del sector público para el logro del ODS 6'],
'Whistle-blower protection assessment for achieving SDG 6': ['Evaluación de la protección de denunciantes para el logro del ODS 6'],
'chart1_label_capacity': [['Recursos humanos','calificados'], ['Conocimiento','y datos'], 'Políticas', 'Legal', 'Ciencia', 'Alianzas', 'Equidad', 'Otro'],
'chart2_label_capacity': [['Colaboración con', 'el sector privado'], 'Incentivos financieros', ['Indicadores','de desempeño'], 'Participación ciudadana',
                         ['Participación de las','organizaciones de','la sociedad civil'], ['Acceso a datos','e información'], 'Acuerdos tradicionales', ['Talleres ','de formación'], ['Supervisión ','del desempeño'], 'Otro'],
'chart11_label_policy': [['Ministerio de ','Recursos Hídricos'], ['Otro ministerio','de tutela'], ['Organismos relacionados ','con el agua'],
                         ['Estructura ad-hoc ','de alto nivel'], 'Estructura interministerial',
                         'Programa interinstitucional', ['No existe un ','mecanismo de ','coordinación específico'],'Otro'],
}
//english to french
var en_to_fr = {
    'baseline':'Base',
    'Unknown/No Data':'Absence de données',
    'current':'Actuel',
    'aspiration (2030)':'Horizon (2030)',
    'not critical':'Pas important',
    'somewhat critical':'Un peu important',
    'significantly critical':'Significativement important',
    'very critical':'Très haut',
    'low capacity':'Capacité Faible',
    'partial capacity':'Capacité Moyenne',
    'significant capacity':'Capacité Importante',
    'complete capacity':'Capacité Complète',
    'no capacity' : 'Capacité adéquate',
    'inadequate capacity':'Capacité insuffisante',
    'adequate capacity':'Aucune capacité',
    'yes':'Oui',
    'no':'Non',
    'unknown':'Inconnu',
    'Unknown':'Inconnu',
    'Generic User': 'Generic User',
    'National Team Member': 'National Team Member',
    'other':'Autre',
    'not applicable':'Non applicable',
    'in development':'En développement',
    //'in development':'En cours',
    'In development':'En cours',
    'lead ministry/ institution 1':'Ministère / Institution Responsable 1',
    'lead ministry/ institution 2':'Ministère / Institution Responsable 2',
    'lead ministry/ institution 3':'Ministère / Institution Responsable 3',
    'detail':'Détails',
    'by consultation':'Par consultation',
    'by law (ad-hoc)':'Par texte réglementaire (ad-hoc)',
    'by law (other)':'Par texte réglementaire (autre)',
    'policy role is not defined':'Rôle de la politique non défini',
    'very important':'Très important',
    'somewhat important':'Assez important',
    'not important':'Pas important',
    'very high':'Très haut',
    'significant':'Significatif',
    'low':'Faible',
    'none':'Aucun',
    'informal only':'Informel seulement',
    'other (describe)':'Autre (Décrivez)',
    'excellent':'Excellent',
    'adequate':'Adéquat',
    'inadequate':'Inadéquat',
    'never':'Jamais',
    'sometimes':'Parfois',
    'often':'Souvent',
    'always':'Toujours',
    'junior':'Cadre agent',
    'senior':'Cadre supérieur',
    'director/executive':'Décideur (DG, PDG, etc.)',
    'male':'Homme',
    'female':'Femme',
    'Score (0-100)': 'Score (0-100)',
    '6.1.1 Proportion of population using': '6.1.1 Pourcentage de la population utilisant',
    'safely managed drinking water services': "des services d'eau potable gérés en toute sécurité",
    '6.2.1 Proportion of population using': '6.2.1 Proportion de la population utilisant des services sanitaires gérés en toute sécurité,',
    'safely managed sanitation services': 'comprenant une installation de lavage des mains avec du savon et de l’eau',
    '6.3.1 Proportion of wastewater safely treated': '6.3.1 Proportion d’eaux usées traitées sans danger',
    '6.3.2 Proportion of water bodies with good ambient water quality': '6.3.2 Proportion des plans d’eau dont la qualité de l’eau ambiante est bonne',
    '6.4.1 Change in water use efficiency over time': '6.4.1 Variation de l’efficacité de l’utilisation des ressources en eau',
    '6.4.2 Level of water stress: freshwater withdrawal': '6.4.2 Niveau de stress hydrique : prélèvements d’eau douce',
    'in percentage of available freshwater resources': 'en proportion des ressources en eau douce disponibles',
    '6.5.1 Degree of integrated water resources management': '6.5.1 Degré de mise en oeuvre de la gestion intégrée des ressources en eau (0-100)',
    '6.5.2 Proportion of transboundary basin area with': '6.5.2 Proportion de bassins hydriques transfrontalières où est en place',
    'an operational arrangement for water cooperation': 'un dispositif opérationnel de coopération en matière d’eau',
    '6.6.1 Change in the extent of water-related ecosystems over time': ['6.6.1 Variation de l’étendue des écosystèmes liés à l’eau dans le temps'],
    'Percentage': 'Pourcentage',
    'Population using improved sanitation services': 'Population utilisant une source d’eau améliorée qui se trouve sur place',
    'Population using hygiene facility with soap and water at home': 'Population utilisant une installation de lavage des mains à l’eau et au savon dans le foyer',
    'Commercial establishments': 'Établissements commerciaux',
    'Non-hazardous industries': 'Industries qui ne présentent pas de danger',
    'Hazardous industries': 'Industries qui présentent de danger',
    'Household sources': 'Ménages',
    'Enabling': 'Politique, planification stratégiqueet','environment score': 'et cadre juridique',
    'Institutions and': 'Cadres de gouvernance','participation score': 'et institutionnels',
    'Management': 'Instruments','instruments score':'de gestion',
    'Financing score': ['Développement des ','infrastructures et ','ressources financières'],
    'Change in the area extent of water-related ecosystems': "Changement dans l'étendue des écosystèmes liés à l'eau",
    'Change in quantity of water contained within these ecosystems': "Changement de la quantité d'eau contenue dans ces écosystèmes",
    'Capacity building needed at the national level': "Renforcement des capacités nécessaires à l'échelle nationale ",
    'to achieve SDG 6 in the country-building':"pour atteindre l’ODD 6 dans le pays",
    'Capacity available at the national level':"Capacités disponibles à l'échelle nationale",
    //'Financing and expenditure plans developed and publicly':'Capacités disponibles à léchelle nationale',
    'to achieve SDG 6 in the country-available': 'pour atteindre l’ODD 6 dans le pays',
    'Importance of human resources development for implementation of SDG 6': ["Importance du développement des ressources humaines ","pour l’implémentation de l'ODD 6"],
    'Importance of knowledge and data in implementation of SDG 6': "Importance des connaissances et des données pour l’implémentation de l'ODD 6",
    'Importance of human capacity to make policy for the implementation of SDG 6': ["Importance de la capacité à élaborer des politiques pour l’implémentation de l'ODD 6"],
    'Institutions considering structural changes to achieve SDG 6': 'Institutions qui envisagent des changements structurels pour atteindre l’ODD 6',
    "Mechanisms of accountability to prevent and detect":["Mécanismes de responsabilisation pour prévenir et détecter la corruption","pour les indicateurs de l'ODD 6"],
    'Estimated proportion of funds available in relation to': ["Proportion estimée de fonds disponibles par rapport aux fonds nécessaires","pour les indicateurs de l'ODD 6"],
    'Established financial accountability mechanisms for': ['Mise en place de  mécanismes de responsabilisation financière établis pour les', "indicateurs de l'OSD 6"],
    'Financing and expenditure plans developed and publicly': ["Plans de financement et de dépenses élaborés et accessibles au public" ,"pour les indicateurs de l'ODD 6"],
    'Mechanisms for including civil society in the financial':['Mécanismes pour inclure la société civile dans le processus de planification',"financière pour les indicateurs de l'ODD 6"],
    'Securing different funding sources to support national' :['Différentes sources de financement pour soutenir les politiques nationales',"et la mise en œuvre des indicateurs de l'ODD 6"],
    'Incentives for environmentally sustainable and efficient' : ['Incitations à des technologies écologiquement durables et efficaces',"pour les indicateurs de l'ODD 6"],
    'Regulatory processes are simple and transparent ' :["Les processus réglementaires sont simples et transparents pour les ","indicateurs de l'ODD 6"],
    'Public financial management and procurement used to prevent':["Gestion des finances publiques et passation des marchés utilisés pour ", "prévenir et détecter la corruption pour les indicateurs de l'ODD 6"],
    'National policies and implementation plans for SDG 6' : "Politiques nationales et plans de mise en œuvre des indicateurs de l'ODD 6",
    'Mechanisms to reach specific population groups for SDG 6' :["Mécanismes pour atteindre des groupes de population spécifiques pour les","indicateurs de l'ODD 6"],
    'Mechanisms for the allocation of responsibilities among lead': ["Mécanismes de répartition des responsabilités entre les" ,"ministères / institutions chefs de file pour les indicateurs de l'ODD 6"],
    'Mechanisms adopted to address the lack of reliable data for': ["Mécanismes adoptés pour remédier au manque de données fiables pour les " , "indicateurs de l'ODD 6"],

    "Independent reviews of the implementation of DRR":["Évaluations indépendantes de la mise en œuvre des stratégies de RRC" , "pour les indicateurs de l'ODD 6"],

    'Cooperation with private sector to achieve SDG 6' : ["Coopération avec le secteur privé pour atteindre les","indicateurs de l'ODD 6"],
    'Cooperation with the development partners (international organizations, donors, NGOs)':["Coopération avec les partenaires au développement (organisations internationales, donateurs, ONG) pour atteindre","les indicateurs de l'ODD 6"],
    'Level of cooperation and exchange of information with other':["Niveau de coopération et d'échange d'informations avec d'autres pays pour","les indicateurs de l'ODD 6"],
    'Public awareness campaigns organized to inform citizens on':['Campagnes de sensibilisation organisées pour informer les citoyens sur',"les défis et les progrès des indicateurs de l'ODD 6"],
    'Gender mainstreaming objectives considered for':["Objectifs d'intégration de la dimension de genre pris en compte pour les","indicateurs de l'ODD 6"],
    'Gender analysis undertaken to inform national policies ':["Analyse de genre entreprise pour éclairer les politiques nationales pour les","indicateurs de l'ODD 6"],
    'Gender dimensions incorporated by national stakeholders ':["Dimensions de genre incorporées par les parties prenantes nationales dans","les études des indicateurs de l'ODD 6"],
    'Adequate resources allocated to implement gender ':["Ressources adéquates allouées à la mise en œuvre des objectifs d'intégration","de la dimension de genre pour les indicateurs de l'ODD 6"],
    'Inclusion of gender specialists in decison-making processes' : ["Inclusion de spécialistes de genre dans les processus de prise de décision pour","les indicateurs de l'ODD 6"],
    'Training to raise awareness on gender equality within lead' : ["Formation pour sensibiliser à l'égalité de genre au sein des","ministères / institutions chefs de file pour les indicateurs de l'ODD 6"],
    'Staff in lead Ministries/Institutions for each SDG 6 indicator': ["Personnel des ministères / institutions chefs de file pour chaque","indicateur de l'ODD 6"],
    'National DRR strategies adopted in line ':['Stratégies nationales de RRC adoptées conformément au Cadre de Sendai',"pour les indicateurs de l'ODD 6"],
    'Integration of climate change adaptation into ': ["Intégration de l'adaptation au changement climatique dans les","stratégies nationales pour les  indicateurs de l'ODD 6"],
    'National funding mechanisms for DRR strategies for SDG 6 indicators': ["Mécanismes nationaux de financement des stratégies de RRC pour les","indicateurs de l'ODD 6"],
    'Indedpendent reviews of the implementation of DRR':["Évaluations indépendantes de la mise en œuvre des","stratégies de RRC pour les indicateurs de l'ODD 6"],
    'Hazard and risk data accessible and available to the public': ["Données sur les dangers et les risques accessibles et mises à la disposition du public pour","les indicateurs de l'ODD 6"],
    'Predicted economic loss and funds allocated to address':['Perte économique prévue et fonds alloués à la reconstruction des',"infrastructures pour chaque indicateur de l'ODD 6"],
    'Mechanism Of accountability to prevent and detect' : ['Mécanismes de responsabilisation pour prévenir et détecter',"la corruption pour les indicateurs de l'ODD 6"],
    'Fair and equitable access to the development and implementation':["Accès juste et équitable à l'élaboration et à la mise en œuvre","de politiques pour les indicateurs de l'ODD 6"],
    'Regulatory process are simple and transparent ':['Les processus réglementaires sont simples et transparents pour les',"indicateurs de l'ODD 6"],
    'Anti-corruption action plans shared between government and ':["Plans d'action anti-corruption partagé entre le gouvernement et les bailleurs de","fonds pour les indicateurs de l'ODD 6"],
    'Public financial Management and procurement used to prevent' : ["Gestion des finances publiques et passation des marchés utilisés pour prévenir et détecter la","corruption pour les indicateurs de l'ODD 6"],
    'Lack of staff and time as an obstacle to achieve SDG 6': "Manque d'employé(e)s et de temps comme obstacle pour atteindre l’ODD 6",
    'Mechanisms existing for cooperation with private sector to achieve SDG 6': ["Mécanismes existants pour la coopération avec le secteur ","privé afin d'atteindre l'ODD 6"],
    'Level of cooperation with other countries to achieve SDG 6': "Niveau de coopération avec les autres pays pour atteindre l'ODD 6",
    'Development partners collaborating with government for each SDG 6 indicator': ["Partenaires pour le développement qui collaborent avec le gouvernement ","pour chaque indicateur de l’ODD 6"],
    'Number of partners': 'Nombre de partenaires',
    'Number of events': "Nombre d'événements",
    'Number of employees': 'Nombre d’employé(e)s',
    'SDG 6 indicator': 'Indicateur de l’ODD 6',
    'Mechanisms addressing capacity building at the national':"Mécanismes traitant du renforcement des capacités à l'échelle nationale pour les indicateurs de l'ODD 6",
    'Level of available capacity at the national level':"Niveau de capacité disponible è l'échelle nationale pour atteindre les indicateurs de l'ODD 6",
    'Availability of financial flows for each SDG 6 Indicators': "Disponibilité des flux financiers pour chaque indicateur de l'ODD 6",
    'Lead Ministries/Institutions on track to build critical':["Ministères / institutions chefs de file en bonne voie pour renforcer les capacités essentielles pour soutenir ","les plans d'action pour les indicateurs de l'ODD 6"],
    'Estimated funds to achieve each SDG 6 indicators by 2030': "Fonds estimés pour atteindre chaque indicateur de l'ODD 6 d'ici 2030",
    'Funds needed and available for each SDG 6 indicators in the current year': "Fonds nécessaires et fonds disponibles pour chaque indicateur de l'ODD 6 dans l'année en cours",
    'Progress on accountability, attracting funds and funding for equity': ["Progrès en matière de responsabilité, d'attraction de fonds et de financement pour l'équité"],
    'Mechanisms for including civil society in': ["Mécanismes pour inclure la société civile dans le", "processus planification financière pour l'ODD 6"],
    'Available funds as % of funds needed': "Fonds disponibles en % des fonds nécessaires",
    'Positive responses for financial flows': "Réponses positives pour les flux financiers",
    'Funds available (\'000,000 USD)': "Fonds disponibles (‘000,000 USD)",
    'Funds needed (\'000,000 USD)': "Fonds nécessaires (‘000,000 USD)",
    'Accountability': 'Responsabilité financière',
    'Attracting funds': 'Attraction de fonds',
    'Funding for equity': "Financement pour l'équité",
    'Gender considerations incorporated by national stakeholders': ["Questions de genre incorporées aux études faites par les parties prenantes",
                                 "à l'échelle nationale pour contribuer à l'ODD 6"],
    'Gender analysis undertaken to inform national policy': ["Analyse réalisée pour informer les réponses politiques nationales",
                                 "aux questions de genre pour l'ODD 6"],
    'Resources allocation by lead ministry to implement': ["Allocation de ressources par le ministère responsable pour la mise en œuvre",
                                 "de stratégies pour les questions de genre pour l'ODD 6"],
    'Performance-based mechanisms for staff to pursue gender':["Mécanismes basés sur la performance permettant au personnel de poursuivre",
                                 "l'intégration de questions de genre dans le milieu de travail pour l’ODD 6"],
    // 'Predicted economic loss and funds allocated to address' :['Perte économique prévue et fonds alloués pour la reconstruction des infrastructures',
    //                              'après une catastrophe pour chaque indicateur de l’ODD 6'],
    'Protection plans implemented for critical': ['Plans de protection mis en œuvre pour les infrastructures',
                    "critiques pour la réalisation de l'ODD 6"],
    'Proportion of critical public infrastructure located in': ["Proportion d'infrastructures publiques critiques situées dans des zones",
                    "à risque de catastrophe pour chaque indicateur de l'ODD 6"],
    'Proportion of critical public infrastructure with hazard, risk and': ["Proportion d'infrastructures publiques critiques pour lesquelles une analyse de danger,",
                    "de risque et de vulnérabilité a déjà été réalisée pour chaque indicateur de l'ODD 6"],
    'Predicted economic loss': 'Perte économique prévue',
    'Funds allocated for post-disaster infrastructure reconstruction': 'Fonds alloués pour la reconstruction des infrastructures après une catastrophe',
    'Transparency in formulation of new policies and implementation': ['Transparence dans la formulation des nouvelles politiques et mise en œuvre des',
              "réglementations et politiques existantes pour chaque indicateur de l'ODD 6"],
    'Fair and equitable access of stakeholders to the': ["Accès juste et équitable des parties prenantes à l'élaboration et à la mise",
              "en œuvre de politiques pour l'ODD 6"],
    'Integrity training promoted at least once a year': ["Formation à l'intégrité promue au moins une fois par an dans le(s) ",
              "ministère(s) / institution(s) responsable(s) pour l'ODD 6"],
    'Formulation of new policies': 'Formulation des nouvelles politiques',
    'Implementation of existing regulations': 'Mise en œuvre des réglementations existantes',
    "No evidence": "Absence de données",
    "Significant": "Significatif",
    "Adequate": "Adéquat",
    "Inadequate": "Inadéquat",
    "In progress": "En cours",
    "Capacity": "Capacité",
    "DRR/Resilience": "Réduction des risques de catastrophes et résilience",
    "Finance": "Finances",
    "Gender": "Genre",
    "Indicator": "Indicateur",
    "Integrity": "Intégrité",
    "Policy & Institutional": "Politique et Évaluation Institutionnelle",
    "Target": "Cible",
    "Overall Progress": "Progression globale",
    //"Overall current capacity": "Capacité actuelle totale",
    "Overall current capacity": "Capacité effective",
    "Strengthening mechanisms": "Mécanismes de renforcement",
    "Information and Assessments": "Mécanismes de financement",
    //"Infrastructure": "Infrastructures",
    "Infrastructure": "Accessibilité des données",
    "Strategies": "Planification stratégique",
    // "Adequacy of financial flows": "Adéquation des flux financiers",
    "Adequacy of financial flows": "Planification financière",
    "Financing for equity": "Incitations publiques",
    "Funding Sources": "Redevabilité",
    "Governance": "Participation des femmes",
    "National policy": "Analyse de genre",
    "Organisation mainstreaming": "Formation et ressources",
    "Policy and Integrity": "Responsabilité et transparence",
    "Public Sector Integrity": "Justice et équité",
    "Whistle-blower Protection": "Processus réglementaires",
    "Awareness": "Sensibilisation du public",
    "Coordination & cooperation": "Coordination et coopération",
    "Policy for equity": "Planification des politiques et équité",
    "Level of available capacity at the national level for achieving SDG 6": "Niveau de capacité disponible à l’échelle nationale pour atteindre l'ODD 6",
    'Long-term policy options and mechanisms for building critical ':['Politiques et mécanismes à long terme pour le renforcement ',"des capacités critiques à l’échelle nationale pour l'ODD 6"],
    'Human resources development ': ['Développement et amélioration ', 'des ressources humaines'],
    'Access to information ': ["Accès à l'information ","et au savoir"],
    'Science, technology ': ['Science, technologie ','et innovation'],
    'Inclusion, participation, ': ['Inclusion, participation, équité et ','autonomisation des groupes exclus, ','tels que les minorités'],
    'Status of policies to align and inform on investments to ': ["État d'avancement des politiques visant à aligner les investissements destinés ","à atteindre les objectifs d'intégration de la dimension de genre pour l'ODD 6"],
    'Status of resources allocated to implement gender ': ["État des ressources allouées à la mise en œuvre des objectifs d'intégration ","de la dimension de genre dans l'ODD 6"],
    'Consultation with national gender specialists in decision-making for SDG 6': ["Consultation avec des spécialistes nationaux en matière de genre dans","la prise de décision pour l'ODD 6"],
    'Institutional commitment to promote gender equality for achieving SDG 6': ["Engagement institutionnel pour l'égalité des genres ","pour la réalisation de l'ODD 6"],
    //'Staff in lead Ministries/Institutions for each SDG 6 indicator': ["Personnel dans les principaux Ministères / Institutions pour", "chaque indicateur de l'ODD 6"],
    'Staff responsible for addressing water related gender issues in': ["Personnel chargé de traiter les questions de genre liées à l'eau dans ","les principaux Ministères / Institutions pour chaque indicateur de l'ODD 6"],
    'Annual status of training to raise awareness on gender ': ["Statut des formations pour susciter la prise de conscience sur les questions ","de genre dans les principaux Ministères / Institutions pour l'ODD 6"],
    'Public awareness efforts led by the national government for achieving SDG 6': ["Efforts menés par le gouvernement national pour la sensibilisation"," du public pour la réalisation de l'ODD 6"],
    'Status of water related policies for equity at national level for achieving SDG 6 ':["État des politiques relatives à l'eau pour l'équité ","à l’échelle nationale pour la réalisation de l'ODD 6"],
    'Challenges in water policymaking at national level for achieving SDG 6': ["Défis dans l’élaboration des politiques de l'eau à l’échelle ","nationale pour la réalisation de l'ODD 6"],
    'Events, meetings and workshops organized by the government for each SDG 6 indicator': ["Événements, réunions et ateliers organisés par ","le gouvernement pour chaque indicateur de l'ODD 6"],
    'Status of national policies and implementation plans for achieving SDG 6': ["État d'avancement des politiques nationales et des plans ","de mise en œuvre pour la réalisation de l'ODD 6"],
    'Attribution of roles at the national level for SDG 6': ["Attribution des rôles à l'échelle nationale pour l'ODD 6"],
    'chart10_label_policy_component': ["Pas d'implémentation",'Implémentation partielle','Implémentation complète'],
    'chart8_label_policy_component': [['Inadéquation entre les ','limites hydrologiques ', 'et administratives'],['Allocation des ','ressources en eau'],
                                    ['Capacite des ','gouvernements locaux ', 'et régionaux'], ['Application des normes ','environnementales'],
                                    'Règlementation économique', ['Participation ','citoyenne']],
    'chart7_label_policy_component': ['Populations pauvres',['Populations vivant dans ','des bidonvilles ou ','des lieux informels'],
                                    ['Populations vivant dans ','des régions isolées ou ','difficilement accessibles'],
                                    'Populations autochtones',['Personnes déplacées ','et / ou réfugiées'],'Femmes',
                                    'Minorités ethniques', 'Personnes handicapées',['Populations accablées ','de maladies']],
    'Status of national DRR strategies adopted in line with the ': ['Statut des stratégies nationales de réduction des risques de ','catastrophe adoptées en conformité avec le Cadre de Sendai pour ',"soutenir la réalisation de l'ODD 6"],
    'Status of integrating climate change adaptation into ': ["État d’intégration de l’adaptation aux changements climatiques ","dans les stratégies nationales pour l’ODD 6 "],
    'Status of national funding mechanisms for DRR in support of SDG 6': ["Statut des mécanismes nationaux de financement pour la réduction ","des risques de catastrophe pour soutenir la réalisation de l'ODD 6"],
    'Status of independent reviews of the implementation of ': ["État des révisions indépendantes de la mise en œuvre des ","stratégies de réduction des risques de catastrophe pour l'ODD 6"],
    'Availability status of multi-hazard national risk assessments for SDG 6': ["État de la disponibilité des évaluations multirisques nationales ","pour l'ODD 6"],
    'Status of policies and mechanisms to make hazard and ': ["État des politiques et des mécanismes pour rendre les données sur les ","dangers et les risques disponibles et accessibles au public pour l'ODD 6"],
    'Programmes to enhance awareness on water-related disaster risks for SDG 6': ["État des programmes de sensibilisation aux risques de catastrophe ","liés à l'eau pour l'ODD 6"],
    'Status of funding for post-disaster infrastructure rehabilitation for SDG 6': ["État des fonds pour la remise en état des infrastructures après la ","catastrophe pour l'ODD 6"],
    'Integrity assessment of water related policymaking for each SDG 6': ["Évaluation de l'intégrité dans l'élaboration des politiques relatives ","à l'eau pour atteindre l'ODD 6"],
    'Integrity assessment of regulatory processes for achieving SDG 6': ["Évaluation de l'intégrité dans les processus réglementaires pour ","atteindre l'ODD 6"],
    'Integrity assessment of international funding for achieving SDG 6': ["Évaluation de l'intégrité dans le financement international pour ","atteindre l'ODD 6"],
    'Public sector integrity assessment for achieving SDG 6': ["Évaluation de l'intégrité dans le secteur public pour ","atteindre l'ODD 6"],
    'Whistle-blower protection assessment for achieving SDG 6': ["Évaluation de la protection des dénonciateurs pour atteindre l'ODD 6"],
    'chart1_label_capacity': ['Capacités humaines', 'Connaissance et données', 'Cadres politiques', 'Cadres juridiques', 'Science', 'Partenariats', 'Équite', 'Autre'],
    'chart2_label_capacity': [['Collaboration avec ','le secteur privé'], 'Incitations financières', ['Indicateurs de ','performance'],['Participation ','des citoyens'],
                             ['Participation des ','organisations de ', 'la société civile'], 'Données', 'Arrangements traditionnels', 'Formations', ['Monitorage de ','la performance'], 'Autre'],
    'chart11_label_policy': [['Ministère des ','Ressources en Eau'], 'Autre Ministère de tutelle', ["Organismes ","liés à l'eau"],
                             ['Structure de haut ','niveau ad-hoc'], 'Structure interministérielle',
                             'Programme inter-agences', ['Aucun mécanisme ','de coordination','spécifique'],'Autre'],
    }

var en_to_en = {
'baseline':'Baseline',
'current':'Current',
'aspiration (2030)':'Aspiration (2030)',
'not critical':'Not critical',
'somewhat critical':'Somewhat critical',
'significantly critical':'Significantly critical',
'very critical':'Very critical',
'low capacity':'Low Capacity',
'partial capacity':'Partial Capacity',
'significant capacity':'Significant Capacity',
'complete capacity':'Complete Capacity',
'Adequate':'Adequate',
'Inadequate':'Inadequate',
'yes':'Yes',
'no':'No',
'unknown':'Unknown',
'Unknown':'Unknown',
'Generic User': 'Generic User',
'National Team Member': 'National Team Member',
'other':'Other',
'not applicable':'Not Applicable',
'in development':'In development',
'In development': 'In development',
'Unknown/No Data':'Unknown/No Data',
'lead ministry/ institution 1':'Lead Ministry/ Institution 1',
'lead ministry/ institution 2':'Lead Ministry/ Institution 2',
'lead ministry/ institution 3':'Lead Ministry/ Institution 3',
'Lead Ministry/ Institution': 'Lead Ministry/ Institution',
'detail':'Detail',
'by consultation':'By consultation',
'by law (ad-hoc)':'By law (ad-hoc)',
'by law (other)':'By law (other)',
'policy role is not defined':'Policy role is not defined',
'very important':'Very important',
'somewhat important':'Somewhat important',
'not important':'Not important',
'very high':'Very High',
'significant':'Significant',
'low':'Low',
'none':'None',
'informal only':'Informal Only',
'other (describe)':'Other (Describe)',
'excellent':'Excellent',
'adequate':'Adequate',
'inadequate':'Inadequate',
'never':'Never',
'sometimes':'Sometimes',
'often':'Often',
'always':'Always',
'junior':'Junior',
'senior':'Senior',
'director/executive':'Director/Executive',
'male':'Male',
'female':'Female',
'Score (0-100)': 'Score (0-100)',
'6.1.1 Proportion of population using': '6.1.1 Proportion of population using',
'safely managed drinking water services': 'safely managed drinking water services',
'6.2.1 Proportion of population using': '6.2.1 Proportion of population using',
'safely managed sanitation services': 'safely managed sanitation services',
'6.3.1 Proportion of wastewater safely treated': '6.3.1 Proportion of wastewater safely treated',
'6.3.2 Proportion of water bodies with good ambient water quality': '6.3.2 Proportion of water bodies with good ambient water quality',
'6.4.1 Change in water use efficiency over time': '6.4.1 Change in water use efficiency over time',
'6.4.2 Level of water stress: freshwater withdrawal': '6.4.2 Level of water stress: freshwater withdrawal',
'in percentage of available freshwater resources': 'in percentage of available freshwater resources',
'6.5.1 Degree of integrated water resources management': '6.5.1 Degree of integrated water resources management',
'6.5.2 Proportion of transboundary basin area with': '6.5.2 Proportion of transboundary basin area with',
'an operational arrangement for water cooperation': 'an operational arrangement for water cooperation',
'6.6.1 Change in the extent of water-related ecosystems over time': ['6.6.1 Change in the extent of water-related ecosystems over time'],
'Percentage': 'Percentage',
'Population using improved sanitation services': 'Population using improved sanitation services',
'Population using hygiene facility with soap and water at home': 'Population using hygiene facility with soap and water at home',
'Commercial establishments': 'Commercial establishments',
'Non-hazardous industries': 'Non-hazardous industries',
'Hazardous industries': 'Hazardous industries',
'Household sources': 'Household sources',
'Enabling': 'Enabling','environment score': 'environment score',
'Institutions and': 'Institutions and','participation score': 'participation score',
'Management': 'Management','instruments score':'instruments score',
'Financing score': 'Financing score',
'Integrity assessment of water related policymaking for each SDG 6':'Integrity assessment of water related policymaking for each SDG 6',
'Integrity assessment of regulatory processes for achieving SDG 6':'Integrity assessment of regulatory processes for achieving SDG 6',
'Change in the area extent of water-related ecosystems': 'Change in the area extent of water-related ecosystems',
'Change in quantity of water contained within these ecosystems': 'Change in quantity of water contained within these ecosystems',
'Mechanisms addressing capacity building at the national': 'Mechanisms addressing capacity building at the national level for SDG 6 indicators',
'to achieve SDG 6 in the country-building':'to achieve SDG 6 in the country',
'Capacity available at the national level':'Capacity available at the national level',
'Level of available capacity at the national level':'Level of available capacity at the national level for achieving SDG 6 indicators',
'to achieve SDG 6 in the country-available': 'to achieve SDG 6 in the country',
'for acheiving SDG 6 indicator':'for acheiving SDG 6 indicator',
'level for SDG 6 indicators':'level for SDG 6 indicators',
'Importance of human resources development for implementation of SDG 6': ['Importance of human resources development for implementation of SDG 6'],
'Lead Ministries/Institutions on track to build critical':['Lead Ministries/Institutions on track to build critical','capacity to support action plans for SDG 6 indicators'],
'Importance of knowledge and data in implementation of SDG 6': 'Importance of knowledge and data in implementation of SDG 6',
'Importance of human capacity to make policy for the implementation of SDG 6': ['Importance of human capacity to make policy for the implementation of SDG 6'],
'Institutions considering structural changes to achieve SDG 6': 'Institutions considering structural changes to achieve SDG 6',
'Lack of staff and time as an obstacle to achieve SDG 6': 'Lack of staff and time as an obstacle to achieve SDG 6',
'Mechanisms existing for cooperation with private sector to achieve SDG 6': ['Mechanisms existing for cooperation with private sector to achieve SDG 6'],
'Level of cooperation with other countries to achieve SDG 6': 'Level of cooperation with other countries to achieve SDG 6',
'Development partners collaborating with government for each SDG 6 indicator': ['Development partners collaborating with government for each SDG 6 indicator'],
'Number of partners': 'Number of partners',
'Number of events': 'Number of events',
'Number of employees': 'Number of employees',
'SDG 6 indicator': 'SDG 6 indicator',
'Availability of financial flows for each SDG 6 Indicators': 'Availability of financial flows for each SDG 6 Indicators',
'Financing and expenditure plans developed and publicly': ['Financing and expenditure plans developed and publicly' ,' available for SDG 6 indicators'],
'Estimated funds to achieve each SDG 6 indicators by 2030': 'Estimated funds to achieve each SDG 6 indicator by 2030',
'Estimated proportion of funds available in relation to': ['Estimated proportion of funds available in relation to',  ' funds needed for SDG 6 indicators'],
'Funds needed and available for each SDG 6 indicators in the current year': 'Funds needed and available for each SDG 6 indicator in the current year',
'Progress on accountability, attracting funds and funding for equity': ['Progress on accountability, attracting funds and funding for equity'],
'Securing different funding sources to support national': ['Securing different funding sources to support national', 'policies and implementation for SDG 6 indicators'],
'Mechanisms for the allocation of responsibilities among lead': ['Mechanisms for the allocation of responsibilities among lead', 'Ministries/Institutions for SDG 6 indicators'],
'National policies and implementation plans for SDG 6': 'National policies and implementation plans for SDG 6 indicators',
'Mechanisms adopted to address the lack of reliable data for':'Mechanisms adopted to address the lack of reliable data for SDG 6 indicators',
'Cooperation with private sector to achieve SDG 6': ['Cooperation with private sector to achieve SDG 6', 'indicators'],
'Cooperation with development partners(international': ['Cooperation with development partners(international', 'organizations,donors,NGOs) to achieve SDG 6 indicators'],
'Cooperation with the development partners (international organizations, donors, NGOs)':['Cooperation with the development partners (international organizations, donors, NGOs)','to achieve SDG 6 indicators'],
'Level of cooperation and exchange of information with other': ['Level of cooperation and exchange of information with other', 'countries for SDG 6 indicators'],
'Public awareness campaigns organized to inform citizens on': ['Public awareness campaigns organized to inform citizens on', 'challenges and progress for SDG 6 indicators'],
'Mechanisms to reach specific population groups for SDG 6': 'Mechanisms to reach specific population groups for SDG 6 indicators',
'Incentives for environmentally sustainable and efficient': ['Incentives for environmentally sustainable and efficient', 'technologies for SDG 6 indicators'],
'Mechanisms for including civil society in the financial': ['Mechanisms for including civil society in the financial', 'planning process for SDG 6 indicators'],
'Established financial accountability mechanisms for': ['Established financial accountability mechanisms for', ' SDG 6 indicators'],
'Available funds as % of funds needed': 'Available funds as % of funds needed',
'Positive responses for financial flows': 'Positive responses for financial flows',
'Funds available (\'000,000 USD)': 'Funds available (\'000,000 USD)',
'Funds needed (\'000,000 USD)': 'Funds needed (\'000,000 USD)',
//'Accountability': 'Financial accountability',
'Accountability': 'Accountability',
'Attracting funds': 'Attracting funds',
'Funding for equity': 'Funding for equity',
'Gender considerations incorporated by national stakeholders': ['Gender considerations incorporated by national stakeholders',
                             'in their studies to contribute to SDG 6'],
'Gender analysis undertaken to inform national policy': ['Gender analysis undertaken to inform national policy',
                             'responses to gender issues for SDG 6'],
'Gender mainstreaming objectives considered for': ['Gender mainstreaming objectives considered for',
                             'SDG 6 indicators'],

'Resources allocation by lead ministry to implement': ['Resources allocation by lead ministry to implement',
                             'gender strategies for SDG 6'],
'Gender dimensions incorporated by national stakeholders ': ['Gender dimensions incorporated by national stakeholders ',
                             'on studies for SDG 6 indicators'],
'Performance-based mechanisms for staff to pursue gender':['Performance-based mechanisms for staff to pursue gender',
                             'mainstreaming in their work for SDG 6'],
'Predicted economic loss and funds allocated to address' :['Predicted economic loss and funds allocated to address',
              'infrastructure reconstruction for each SDG 6 indicator'],
'Protection plans implemented for critical': ['Protection plans implemented for critical',
              'infrastructure for achieving SDG 6'],
'Proportion of critical public infrastructure located in': ['Proportion of critical public infrastructure located in',
              'disaster risk areas related to each SDG 6 indicator'],
'Proportion of critical public infrastructure with hazard, risk and': ['Proportion of critical public infrastructure with hazard, risk and',
              'vulnerability analysis already completed for each SDG 6 indicator'],
'Predicted economic loss': 'Predicted economic loss',
'Funds allocated for post-disaster infrastructure reconstruction': 'Funds allocated for post-disaster infrastructure reconstruction',
'Mechanism of accountability to prevent and detect': ['Mechanism of accountability to prevent and detect',
          'corruption of SDG 6 indicators'],
'Fair and equitable access of stakeholders to the': ['Fair and equitable access of stakeholders to the',
          'development and implementation of policies for SDG 6 indicators'],
'Regulatory processes are simple and transparent': ['Regulatory processes are simple and transparent',
          'for SDG 6 indicators'],
'Formulation of new policies': 'Formulation of new policies',
'Implementation of existing regulations': 'Implementation of existing regulations',
"No evidence": "No evidence",
"Significant": "Significant",
"In progress": "In progress",
"Capacity": "Capacity",
"DRR/Resilience": "DRR/Resilience",
"Finance": "Finance",
"Gender": "Gender",
"Indicator": "Indicator",
"Integrity": "Integrity",
"Policy & Institutional": "Policy & Institutional",
"Target": "Target",
"Overall Progress": "Strengthening mechanisms",
//old
//"Overall current capacity": "Overall current capacity",
//sdgpss part2
"Overall current capacity": "Current capacity",
"Strengthening mechanisms": "Overall Progress",
//commented old one
//"Information and Assessments": "Information and Assessments",
//new according to pss part2
"Information and Assessments": "Funding Mechanisms",

"Funding Mechanisms":"Funding Mechanisms",

//"Infrastructure": "Infrastructures",

"Infrastructure": "Infrastructures",

"Data accessiblilty" : "Data accessiblilty",

"Strategies": "Strategical Planning",
//"Adequacy of financial flows": "Adequacy of financial flows",

"Adequacy of financial flows": "Accountability",


"Financing for equity": "Public Incentives",
"Funding Sources": "Financial Planning",

//"Funding Sources": "Public Incentives",

//"Governance": "Governance",

"Governance": "Participation Of Women",

//"National policy": "National policy",
"National policy": "Gender analysis",
//"Organisation mainstreaming": "Gender training",                   //Renamed it

"Organisation mainstreaming": "Training and Resources",

//"Policy and Integrity": "Policy and Integrity",

"Policy and Integrity": "Accountability and Transparency",


//"Public Sector Integrity": "Public Sector Integrity",

"Public Sector Integrity": "Fairness and equity",


//"Whistle-blower Protection": "Whistleblower Protection",

"Whistle-blower Protection": "Regulatory process",



"Awareness": "Public awareness",
"Coordination & cooperation": "Coordination & cooperation",
//"Policy for equity": "Policy for equity",
"Policy for equity": "Policy Planning and Equity",
"Level of available capacity at the national level for achieving SDG 6": "Level of available capacity at the national level for achieving SDG 6",
'Long-term policy options and mechanisms for building critical ':['Long-term policy options and mechanisms for building critical ','capacity at the national level for each SDG 6 indicator'],
'Human resources development ': ['Human resources development ', 'and improvement'],
'Access to information ': ['Access to information ','and knowledge'],
'Science, technology ': ['Science, technology ','and innovation'],
'Inclusion, participation, ': ['Inclusion, participation, ','equity and empowerment of excluded ','groups, such as minorities'],
'Status of policies to align and inform on investments to ': ['Status of policies to align and inform on investments to ','fulfill gender mainstreaming goals for SDG 6'],
'Status of resources allocated to implement gender ': ['Status of resources allocated to implement gender ','mainstreaming goals for SDG 6'],
'Adequate resources allocated to implement gender ': ['Adequate resources allocated to implement gender ','mainstreaming goals for SDG 6 indicators'],
'Gender analysis undertaken to inform national policies ': ['Gender analysis undertaken to inform national policies ','for SDG 6 indicators'],
'Consultation with national gender specialists in decision-making for SDG 6': ['Consultation with national gender specialists in decision-making for SDG 6'],
'Inclusion of gender specialists in decison-making processes': ['Inclusion of gender specialists in decison-making processes','for SDG 6 indicators'],
'Institutional commitment to promote gender equality for achieving SDG 6': ['Institutional commitment to promote gender equality for achieving SDG 6'],
'Training to raise awareness on gender equality within lead': ['Training to raise awareness on gender equality within lead','Ministries/Institutions for SDG 6 indicators'],
'Staff in lead Ministries/Institutions for each SDG 6 indicator': ['Staff in lead Ministries/Institutions for each SDG 6 indicator'],
'Staff responsible for addressing water related gender issues in': ['Staff responsible for addressing water related gender issues in','lead Ministries/Institutions for each SDG 6 indicators'],
'Annual status of training to raise awareness on gender ': ['Annual status of training to raise awareness on gender ','equality within lead Ministries/Institutions for SDG 6'],
'Public awareness efforts led by the national government for achieving SDG 6': ['Public awareness efforts led by the national government for achieving SDG 6'],
'Status of water related policies for equity at national level for achieving SDG 6 ':['Status of water related policies for equity at national level for achieving SDG 6 '],
'Challenges in water policymaking at national level for achieving SDG 6': ['Challenges in water policymaking at national level for achieving SDG 6'],
'Events, meetings and workshops organized by the government for each SDG 6 indicator': ['Events, meetings and workshops organized by the government for each SDG 6 indicator'],
'Status of national policies and implementation plans for achieving SDG 6': ['Status of national policies and implementation plans for achieving SDG 6'],
'Attribution of roles at the national level for SDG 6': ['Attribution of roles at the national level for SDG 6'],
'chart10_label_policy_component': ['No implementation','Partial implementation','Complete implementation'],
'chart8_label_policy_component': [['Hydrological and ','administrative boundaries'],['Allocation of ','water resources'],
                                ['Local and regional',' government capacity'], ['Enforcement of ','environmental norms'],
                                'Economic regulation', ['Limited public ','participation']],
'chart7_label_policy_component': ['Poor populations',['Populations living in',' informal settlements'],['Populations living',' in remote areas'],
                                'Indigenous populations',['Internally displaced ','persons and/or refugees'],'Women and girls',
                                'Ethnic minorities', 'People with disabilities',['Populations with high',' burden of diseases']],
'Status of national DRR strategies adopted in line with the ': ['Status of national DRR strategies adopted in line with the ','Sendai Framework to support the achievement of SDG 6'],
'National DRR strategies adopted in line ':['National DRR strategies adopted in line ','with the Sendai Framework for SDG 6 indicators'],
'Status of integrating climate change adaptation into ': ['Status of integrating climate change adaptation into ','national strategies for SDG 6'],
'Integration of climate change adaptation into ':['Integration of climate change adaptation into ','National Strategies for SDG 6 indicators'],
'Status of national funding mechanisms for DRR in support of SDG 6': ['Status of national funding mechanisms for DRR in support of SDG 6'],
'National funding mechanisms for DRR strategies for SDG 6 indicators':['National funding mechanisms for DRR strategies for SDG 6 indicators'],
'Status of independent reviews of the implementation of ': ['Status of independent reviews of the implementation of ','DRR strategies for SDG 6'],
'Independent reviews of the implementation of DRR':['Independent reviews of the implementation of DRR','strategies for SDG 6 indicators'],
'Hazard and risk data accessible and available to the public': ['Hazard and risk data accessible and available to the public','for SDG 6 indicator'],
'Status of policies and mechanisms to make hazard and ': ['Status of policies and mechanisms to make hazard and ','risk data accessible to public for SDG 6'],
'Programmes to enhance awareness on water-related disaster risks for SDG 6': ['Programmes to enhance awareness on water-related disaster risks for SDG 6'],
'Status of funding for post-disaster infrastructure rehabilitation for SDG 6': ['Status of funding for post-disaster infrastructure rehabilitation for SDG 6'],
'Anti-Corruption action plans shared between government': ['Anti-Corruption action plans shared between government','and donors for SDG 6 Indicator'],
'Mechanisms of accountability to prevent and detect':['Mechanisms of accountability to prevent and detect','corruption for SDG 6 indicators'],
'Public financial management and procurement used to': ['Public financial management and procurement used to',' prevent and detect corruption for SDG 6 indicators'],
'Fair and equitable access to the development and implementation':['Fair and equitable access to the development and implementation','of policies for SDG 6 indicators'],
'Integrity assessment of international funding for achieving SDG 6': ['Integrity assessment of international funding for achieving SDG 6'],
'Regulatory processes are simple and transparent ' :['Regulatory processes are simple and transparent ','for SDG 6 indicators'],
'Public sector integrity assessment for achieving SDG 6': ['Public sector integrity assessment for achieving SDG 6'],
'Anti-corruption action plans shared between government and ' : ['Anti-corruption action plans shared between government and ','donors for SDG 6 indicators'],
'Whistle-blower protection assessment for achieving SDG 6': ['Whistle-blower protection assessment for achieving SDG 6'],
'Public financial management and procurement used to prevent':['Public financial management and procurement used to prevent','and detect corruption for SDG 6 indicators'],
'chart1_label_capacity': ['Human skills', 'Knowledge and data', 'Policy', 'Legal', 'Science', 'Partnerships', 'Equity', 'Other'],
'chart2_label_capacity': ['Private sector collaboration', 'Financial', 'Performance indicators', 'Public participation',
                         'Civil society organiztions', 'Data', 'Traditional arrangements', 'Workshops', 'Performance monitoring', 'Other'],
'chart11_label_policy': ['Minister of Water', 'Line Ministry', ['Central Water ','agency'],
                        ['Ad-hoc high ','level structure'], 'Inter-ministerial body',
                        'inter-agency programme', ['No specific ','coordination ','mechanism'],'Other'],
};

export function findTranslationOptionsIndex(window: Window) {
  const href = window.location.href;
  if (href.indexOf("/fr/") > -1) {
    return 2;
  }
  else if (href.indexOf("/es/") > -1) {
    return 3;
  }
  else if (href.indexOf("/pt/") > -1) {
    return 4;
  }
  else if (href.indexOf("/ko/") > -1) {
    return 5;
  }
  else if (href.indexOf("/ar/") > -1) {
    return 6;
  }
  else {
    return 1;
  }
}

export const option_translations = [{}, en_to_en, en_to_fr, en_to_es,en_to_pt, en_to_ko,en_to_ar ];



// WEBPACK FOOTER //
// ./src/app/sdg/globals/globals.ts